/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_Scope_OnlineInputs */



/**
* | output |
* | --- |
* | "online included" |
*
* @param {Tournaments_Calendar_Scope_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_scope_online = /** @type {((inputs?: Tournaments_Calendar_Scope_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_Scope_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("en ligne inclus")
	if (locale === "es") return /** @type {LocalizedString} */ ("en línea incluidos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("online incluídos")
	if (locale === "it") return /** @type {LocalizedString} */ ("online inclusi")
	return /** @type {LocalizedString} */ ("online included")
});